import React, { useContext, useState } from "react";
import { BiDetail } from "react-icons/bi";
import { BsBadge3D } from "react-icons/bs";
import { FaCode, FaCoffee, FaGithub } from "react-icons/fa";
import { HiTerminal } from "react-icons/hi";
import { IoVideocam, IoVolumeMedium } from "react-icons/io5";
import { MdKeyboardAlt, MdOutlineDesktopWindows } from "react-icons/md";
import { VscEditorLayout } from "react-icons/vsc";
import { Context } from "../../context";
import classes from "./Experiments.module.css";

const ExperimentsCard = ({ card, terminal, setTerminal, setViewMode }) => {
  const parse = require("html-react-parser");
  const { debug, lang } = useContext(Context);
  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const handleClick = (id) => {
    if (id === 1) {
      setViewMode("terminal2d");
    } else if (id === 2) {
      setViewMode("os2d");
    } else if (id === 3) {
      setViewMode("editor2d");
    } else if (id === 4) {
      setViewMode("coinop2d");
    } else if (id === 5) {
      setViewMode("audio2d");
    } else if (id === 6) {
      setViewMode("video2d");
    } else if (id === 7) {
      setViewMode("c642d");
    } else if (id === 8) {
      setViewMode("code2d");
    } else {
      setViewMode("terminal2d");
    }
    setTerminal(true);
  };

  const handleClick3d = (id) => {
    if (id === 1) {
      setViewMode("terminal3d");
    } else if (id === 2) {
      setViewMode("os3d");
    } else if (id === 3) {
      setViewMode("editor3d");
    } else if (id === 4) {
      setViewMode("coinop3d");
    } else if (id === 5) {
      setViewMode("audio3d");
    } else if (id === 6) {
      setViewMode("video3d");
    } else if (id === 7) {
      setViewMode("c643d");
    } else if (id === 8) {
      setViewMode("code3d");
    } else {
      setViewMode("terminal3d");
    }
    setTerminal(true);
  };

  const icons = (id) => {
    if (id === 1) {
      return <HiTerminal className={classes.menuIcon} />;
    } else if (id === 2) {
      return <MdOutlineDesktopWindows className={classes.menuIcon} />;
    } else if (id === 3) {
      return <VscEditorLayout className={classes.menuIcon} />;
    } else if (id === 4) {
      return <FaCoffee className={classes.menuIcon} />;
    } else if (id === 5) {
      return <IoVolumeMedium className={classes.menuIcon} />;
    } else if (id === 6) {
      return <IoVideocam className={classes.menuIcon} />;
    } else if (id === 7) {
      return <MdKeyboardAlt className={classes.menuIcon} />;
    } else if (id === 8) {
      return <FaCode className={classes.menuIcon} />;
    } else {
      return <HiTerminal className={classes.menuIcon} />;
    }
  };

  return (
    <div className="col-md-6 my-1">
      <div className={`${classes.cardWrapper} mb-5`}>
        <div
          key={"democard" + card.id}
          style={{ overflow: "hidden" }}
          className={classes.openedCard2}
        >
          <div
            className={classes.titleCard}
            onClick={() => handleClick(card.id)}
          >
            {icons(card.id)}
            <span>{card.title}</span>
          </div>

          <img src={card.img} alt={card.title} className={classes.demoCard2} />

          <div className={classes.textCard}>
            <div className={`${classes.flexButtons}`}>
              <div className={`${classes.demoCard2Button}`}>
                {card.github && (
                  <a href={card.github} target="_black">
                    <button
                      type="button"
                      className={`${classes.detailsButton} btn btn-info mt-2`}
                    >
                      <FaGithub className={classes.detailsIcon} />
                      Github
                    </button>
                  </a>
                )}

                {card.github2 && (
                  <a href={card.github2} target="_black">
                    <button
                      type="button"
                      className={`${classes.detailsButton} btn btn-info mt-2`}
                    >
                      <FaGithub className={classes.detailsIcon} />
                      Fs api
                    </button>
                  </a>
                )}

                <button
                  type="button"
                  className={`${classes.detailsButton} btn btn-info mt-2`}
                  onClick={() => handleClick(card.id)}
                >
                  <BiDetail className={classes.detailsIcon} />
                  View
                </button>

                <button
                  type="button"
                  className={`${classes.detailsButton} btn btn-info mt-2`}
                  onClick={() => handleClick3d(card.id)}
                >
                  <BsBadge3D className={classes.detailsIcon} />
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperimentsCard;
